import { render, staticRenderFns } from "./bindingpolicy.vue?vue&type=template&id=70096220&scoped=true"
import script from "./bindingpolicy.vue?vue&type=script&lang=js"
export * from "./bindingpolicy.vue?vue&type=script&lang=js"
import style0 from "./bindingpolicy.vue?vue&type=style&index=0&id=70096220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70096220",
  null
  
)

export default component.exports